export const clamp = (val: number, min: number, max: number): number => Math.max(Math.min(val, max), min);